/**
 * A preview is committed by the token the server cached the parse under. A
 * server that predates that flow returns a preview without one, and
 * confirming it is rejected as an invalid request — which reads like a problem
 * with the file. Nothing about the export or the app can fix it, so the
 * mismatch is named instead.
 */
export const OUTDATED_IMPORT_SERVER =
  'This server is running an older version of the import and cannot finish it. Update the server, then try again.';

/** Pulls a displayable message out of an axios rejection. */
export function errorMessage(error) {
  if (!error) return '';

  const data = error?.response?.data;
  if (typeof data === 'string') return data;
  if (data && typeof data === 'object') {
    const { message, error: errorText } = data;
    if (typeof message === 'string') return message;
    if (Array.isArray(message)) return message.join('\n');
    if (typeof errorText === 'string') return errorText;
  }

  const status = error?.response?.status;
  if (status) return `Request failed (${status})`;

  return typeof error?.message === 'string'
    ? error.message
    : 'Something went wrong.';
}
